import styled from 'styled-components'
import { externalContentStyle, breakpoints } from '../../../../constants/style'

export const StyledCareerAdWrapper = styled('section')`
  background-color: #f6f6f6;
  padding-bottom: 5rem;
  * {
    font-family: 'BioSans-Regular', 'Roboto-Regular', sans-serif;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .career-ad__content {
    background: white;
    width: 70%;
    padding: 5rem;
    margin: 0 auto;
    position: relative;
    margin-top: -10rem;
    ${externalContentStyle};

    h1,
    h2,
    h3 {
      margin-top: 0;
      margin-bottom: 1.5rem;
    }

    p,
    ul,
    ol {
      margin-bottom: 1.5rem;
    }

    p,
    li {
      font-size: 1rem;
    }

    li {
      display: flex;
    }
  }

  @media only screen and (max-width: ${breakpoints.desktopLarge}) {
    .career-ad__content {
      width: 100%;
    }
  }

  @media only screen and (max-width: ${breakpoints.tablet}) {
    .career-ad__content {
      margin-top: -7rem;
    }
  }

  @media only screen and (max-width: ${breakpoints.mobile}) {
    padding-bottom: 2rem;
    .career-ad__content {
      padding: 1rem;
      margin-top: -10rem;
    }
  }
`
